import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Validating the Model",
description: "Use Freon’s typing system to validate expressions in your DSL. Learn how to define custom validation rules with type checks that detect mismatched operand types in logical and comparison expressions.",
tags: [ "Freon", "validation", "typing", "type checking", "equalsType", "AndExpression", "OrExpression", "comparison expressions", "validator", "DSL", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};